import React, { useEffect } from "react";
import { Typography, Box, Grid, useMediaQuery } from "@mui/material";
import { connect } from "react-redux";
import { homeActions } from "actions";
import StaticHtmlTemplate from "components/StaticHtmlTemplate";
import { Helmet } from "react-helmet";

const TermsConditions = (props) => {
  const { getContentType, contentInfo, organizationInfo } = props;
  const [termsData, setTermsData] = React.useState("");
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    getContentType("T_AND_C");
    props.setValue(5);
  }, []);

  useEffect(() => {
    if (contentInfo && contentInfo.T_AND_C) {
      setTermsData(contentInfo.T_AND_C);
    }
  }, [contentInfo]);

  return (
    <StaticHtmlTemplate pageTitle="TERMS AND CONDITIONS">
      <Helmet>
        <title>
          Terms and Conditions |{" "}
          {organizationInfo?.app?.appCode === "CVD"
            ? "Cuverd® Partner"
            : "Cuverd®"}
        </title>
        <meta
          name="description"
          content="The Terms and Conditions for using the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta property="og:title" content="Terms and Conditions | Cuverd®" />
        <meta
          property="og:description"
          content="The Terms and Conditions for using the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta
          property="og:image"
          content="assets/images/cuverd-logo-header.svg"
        />
        <link
          rel="alternate"
          href="https://www.cuverd.com/terms-and-conditions"
          hrefLang="en-us"
        />
        <link
          rel="canonical"
          href="https://www.cuverd.com/terms-and-conditions"
        />
      </Helmet>
      <Grid container sx={{ margin: "auto" }} justifyContent="center">
        <Grid item xs={12} sm={10}>
          <Box>
            <Typography variant="h1LatoBold">
              {termsData && termsData?.contentTitle}
            </Typography>
          </Box>
          <Box sx={{ marginTop: "12px" }}>
            <Typography variant="h4LatoRegular" sx={{ color: "#607277" }}>
              Last Modified: {termsData && termsData?.lastModifiedDate}
            </Typography>
          </Box>
          <Box
            sx={{
              paddingTop: "3rem",
              paddingBottom: "3rem",
              marginBottom: "32px",
            }}
          >
            {termsData && termsData?.content && (
              <iframe
                src={`${termsData?.content}?channel=${
                  matchesMinWidth ? "mobileweb" : "web"
                }`}
                frameBorder="0"
                border="0"
                cellSpacing="0"
                style={{ height: "800px", borderStyle: "none", width: "100%" }}
                title="Details"
                scrolling="yes"
              ></iframe>
            )}
          </Box>
        </Grid>
      </Grid>
    </StaticHtmlTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    contentInfo: state.contentType.data,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getContentType: (type) => homeActions.getContentType(type),
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsConditions);
